import { render } from "./CuentaPresupuestos.vue?vue&type=template&id=4aed81f4"
import script from "./CuentaPresupuestos.vue?vue&type=script&lang=js"
export * from "./CuentaPresupuestos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__